<template>
  <div class="pageContainer" v-if="!isFull">
    <div class="pageContainer-left">
      <system-menu @expand="expand" />
    </div>
    <div
      class="pageContainer-right"
      :class="isExpand ? 'pageContainer-right-expand' : ''"
    >
      <div class="pageContainer-tab">
        <div class="pageContainer-tab-left">
          <system-tab />
        </div>
        <div class="pageContainer-tab-right">
          <el-dropdown>
            <span class="el-dropdown-link">
              <el-icon><Tools /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  @click="handleClose('current')"
                  :disabled="itemDisabled"
                  >关闭当前</el-dropdown-item
                >
                <el-dropdown-item
                  @click="handleClose('other')"
                  :disabled="itemDisabled"
                  >关闭其他</el-dropdown-item
                >
                <el-dropdown-item
                  @click="handleClose('right')"
                  :disabled="itemDisabled"
                  >关闭右侧</el-dropdown-item
                >
                <!-- <el-dropdown-item @click="handleClose('all')" disabled>关闭所有</el-dropdown-item> -->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div class="pageContainer-body">
        <router-view />
        <div
          id="portalContainer"
          ref="portalContainer"
          v-loading="loading"
          element-loading-text="页面加载中..."
        ></div>
      </div>
    </div>
  </div>
  <div
    v-else
    id="portalContainer"
    ref="portalContainer"
    v-loading="loading"
    element-loading-text="页面加载中..."
  ></div>
</template>

<script>
import {
  defineComponent,
  reactive,
  getCurrentInstance,
  toRefs,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import { loadMicroApp, start } from "qiankun";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { fa } from "element-plus/es/locale";

export default defineComponent({
  setup() {
    const portalContainer = ref();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const routeTabs = computed(() => store.getters.routeTabs);
    const itemDisabled = computed(() => {
      if (routeTabs.value.length > 1) {
        return false;
      } else {
        return true;
      }
    });

    const state = reactive({
      activeName: "User",
      isExpand: true,
      loading: true,
    });
    onMounted(() => {
      if (!window.qiankunStarted) {
        window.qiankunStarted = true;
        start();
      }
    });
    const expand = (isExpand) => {
      state.isExpand = isExpand;
    };
    const handleClose = (type) => {
      let arr = [];
      if (routeTabs.value.length > 1) {
        switch (type) {
          case "current":
            arr = routeTabs.value.filter((item) => {
              if (route.path !== item.path) {
                return item;
              }
            });
            break;
          case "right":
            arr = routeTabs.value.filter((item, index) => {
              if (
                index <=
                routeTabs.value.findIndex((item) => route.path === item.path)
              ) {
                return item;
              }
            });
            break;
          case "other":
            arr = routeTabs.value.filter((item) => {
              if (route.path === item.path) {
                return item;
              }
            });
            break;
          case "all":
            arr = [];
            break;

          default:
            break;
        }
        store.commit("permission/SET_ROUTE_TABS", arr);
      }
    };
    const isFull = computed(() => {
      if (route.query && route.query && route.query.isFull === "true") {
        return true;
      } else {
        return false;
      }
    });
    watch(
      () => route.path,
      () => {
        if (portalContainer.value && portalContainer.value.children[0]) {
          state.loading = false;
        } else {
          state.loading = true;
        }
      }
    );
    return {
      ...toRefs(state),
      expand,
      handleClose,
      itemDisabled,
      portalContainer,
      isFull,
    };
  },
});
</script>

<style lang="less" scoped>
.pageContainer {
  width: inherit;
  height: calc(100% - 50px);
  display: flex;
  overflow: hidden;

  .pageContainer-left {
    height: 100%;
    width: 200px;
    background: #37507e;
  }

  .pageContainer-right {
    height: 100%;
    width: calc(100% - 200px);

    .pageContainer-tab {
      height: 45px;
      width: 100%;
      display: flex;
      background-color: white;

      .pageContainer-tab-left {
        width: calc(100% - 100px);
        height: 100%;
      }

      .pageContainer-tab-right {
        width: 100px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .pageContainer-body {
      width: calc(100% - 32px);
      height: calc(100% - 64px);
      background-color: #f3f5f9;
      padding: 8px 16px 16px;
      overflow: hidden;
    }
  }
}

#portalContainer {
  width: 100%;
  height: 100%;

  > div {
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="less">
#portalContainer {
  > div {
    width: 100%;
    height: 100%;
  }
}
</style>
